import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { OrderTemplateFormPresentation } from './order-template-form.presentation';
import { OrderTemplateFormVM } from './order-template-form.viewmodel';

export type OrderTemplateFormProps = {
    accountId: number;
    apiCallSuccessCallback: () => void;
    blueprintId?: string;
};

export const OrderTemplateForm = withViewModel(OrderTemplateFormPresentation, async (props: OrderTemplateFormProps) => {
    const vm = new OrderTemplateFormVM(props.accountId, props.apiCallSuccessCallback).withBlueprint(props.blueprintId);
    await vm.load();
    return vm;
});
